import { ComponentProps } from 'react';
import clsx from 'clsx';

import { OpSwitch } from 'new-components/DLS/OpSwitch/OpSwitch';
import { OpSkeleton } from 'new-components/DLS/OpSkeleton/OpSkeleton';

import { useOpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

import './OpFormSwitch.scss';

interface OpFormSwitchProps
  extends Pick<ComponentProps<typeof OpForm.Item>, 'name' | 'initialValue'>,
    Omit<ComponentProps<typeof OpSwitch>, 'name'> {
  formItemClassName?: string;
  isLoading?: boolean;
}

export const OpFormSwitch = ({
  // Form Item props
  formItemClassName,
  name,
  initialValue,

  // For skeleton loading state
  isLoading = false,

  // Wrapped element props
  disabled,

  ...elementProps
}: OpFormSwitchProps) => {
  /** The Form is wrapped in a provider that passes the loading context
   *  to the component */
  const { isDataLoading, isReadOnly } = useOpFormContext();

  return (
    <OpForm.Item
      className={clsx('op-form-switch', formItemClassName)}
      name={name}
      initialValue={initialValue}
      valuePropName="checked"
    >
      {isDataLoading || isLoading ? (
        <OpSkeleton.Button active size="small" shape="circle" />
      ) : (
        <OpSwitch disabled={isReadOnly || disabled} {...elementProps} />
      )}
    </OpForm.Item>
  );
};
